const StarIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M6.00045 9.13L2.47395 11.104L3.26145 7.14L0.293945 4.396L4.30745 3.92L6.00045 0.25L7.69345 3.92L11.7069 4.396L8.73945 7.14L9.52695 11.104L6.00045 9.13ZM6.00045 7.984L8.12395 9.1725L7.64945 6.786L9.43595 5.1335L7.01945 4.847L6.00045 2.6375L4.98145 4.8475L2.56495 5.1335L4.35145 6.786L3.87695 9.1725L6.00045 7.984Z" />
  </svg>
);
  
export default StarIcon;
  